import { apiClient } from '~/api/client';
import { CompanyORLoanOfficerJSONAPI } from '~/sections/dashboard/types';

type IndexParams = {
  period: number;
  value?: string[];
  criteria: string | null;
  block: string;
  limit: number;
  page: number;
};

type IndexResponse = {
  loan_officers: LoanOfficerResonse;
};

type LoanOfficerResonse = {
  data: CompanyORLoanOfficerJSONAPI[];
  meta: {
    total_count: number;
  };
};

export const index = async (params: IndexParams) => {
  if (params.criteria == '') {
    params.criteria = null;
  }
  return apiClient.get<IndexResponse>(`/dashboard/loan_officers`, { params });
};
